export default class ArchiveGroupCtrl {
  constructor(Authentication, PersonaCollection, pluralizeFilter, $uibModalInstance, groups) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      pluralizeFilter,
      $uibModalInstance,
      groups,
    });

    const { type } = this.groups[0];
    this.entityDescription = `${this.pluralizeFilter(
      this.groups,
      'this',
      'these'
    )} ${this.pluralizeFilter(this.groups, type)}`;
    this.conditions = [
      `${this.entityDescription} will become inaccessible for the entire organisation`,
      `All employees will be removed from ${this.entityDescription}`,
      `Future shifts for ${this.entityDescription} will be deleted`,
    ];
    this.conditionValues = [];
    this.shifts = 'delete';
    this.confirmText = `ARCHIVE ${this.pluralizeFilter(this.groups, type).toUpperCase()}`;
  }

  get allConditionsChecked() {
    return this.conditions.every((item, index) => this.conditionValues[index]);
  }

  get isFormValid() {
    return (
      this.allConditionsChecked &&
      (this.shifts === 'delete' || this.to) &&
      this.isConfirmationValid()
    );
  }

  isConfirmationValid() {
    return this.confirmInput.toLowerCase() === this.confirmText.toLowerCase();
  }

  showWarning() {
    return (
      (!this.form.confirmInput.$pristine || this.form.$submitted) && !this.isConfirmationValid()
    );
  }

  submit() {
    if (this.form) {
      this.form.$setSubmitted();
    }

    if (this.isFormValid) {
      this.$uibModalInstance.close({
        shifts: this.shifts,
        to: this.to?.id,
      });
    }
  }
}
